import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import {
  getCookie,
  setCookie
} from 'common/js/cookie.js'
import animated from 'animate.css'

// 第三方包
import 'lib-flexible'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'common/stylus/mintUI.styl'
import 'fastclick'
import LyTab from 'components/Scroll'
import 'swiper/dist/css/swiper.css'
import VueQrcode from '@xkeshi/vue-qrcode'

// 默认主体样式
import 'common/stylus/index.styl'

const Host = 'https://api.xdclass.net'

Vue.use(Mint)
Vue.use(LyTab)
Vue.use(animated)
Vue.component(VueQrcode.name, VueQrcode)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // 获取微信登录后的token
  let currentUrl = location.href
  if (currentUrl.indexOf('access_token=') !== -1) {
    let wechattoken = currentUrl.split('access_token=')[1]
    wechattoken = wechattoken.split('&')[0]
    setCookie('token', wechattoken, 5)
  }
  let token = getCookie('token')
  if (token) {
    store.state.user.info.token = token
    axios.get(`${Host}/pub/api/v1/web/user_info`, {
      params: {
        token
      }
    })
      .then(res => {
        res = res.data
        if (res.code === 0) {
          res = res.data
          res.headImg = res.headImg.replace('http:', 'https:')
          store.state.user.info = Object.assign({}, store.state.user.info, res)

          if(RegExp(/2/).test(res.roles)){
            store.state.user.info.rolesState=true;
          }else if(RegExp(/3/).test(res.roles)){
            let tempD=new Date()
            let currentT=new Date(res.vipExpired).getTime();
            // console.log(tempD.getTime());
            // console.log(currentT);
            console.log(tempD.getTime()<currentT)
            if(tempD.getTime()<currentT){
              store.state.user.info.rolesState=true;
            }
          }

          // store.state.user.info.rolesState = RegExp(/2/).test(res.roles)
        }
      })
      .catch(error => console.log(error))
  } else {
    if (to.path === '/pay' || to.path === '/member') {
      Vue.$toast({
        message: '请先登录账号'
      })
      setTimeout(function () {
        next('/login')
      }, 1500)
    }
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js